import { MID_SESSION_LIST } from "../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import { fetchMidsessionFailure, fetchMidsessionSuccess } from "./reducer";

export const getMidSession = (setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${MID_SESSION_LIST}`,'GET')
        setLoading(false)
        if (response.error && response.error.code === 'NotFound') {
            dispatch(fetchMidsessionSuccess([]));
        }
        else {
            dispatch(fetchMidsessionSuccess(response.reverse()))
        }
    }
    catch (error) {
        setLoading(false)
        dispatch(fetchMidsessionFailure(error.message))
    }
}